import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';

import {DOC_OFFER_EN, DOC_OFFER_ES,DOC_POLICY_EN, DOC_POLICY_ES, INDEX} from '../../config/routes';
import {SelectCurrency} from '../Header/SelectCurrency';
import {SelectLanguage} from '../Header/SelectLanguage';

import logo from './GetMoneyVerticalLogo.svg'
import mc from './mc.svg'
import visa from './visa.svg'

import cls from './Footer.module.scss'

const Footer = () => {

    const {t, i18n} = useTranslation();

    const lang = i18n.language;

    return (
        <div className={cls.footer}>
            <div className={'content'}>
                <div className={cls.wrapper}>
                    <div className={cls.logos}>
                        <Link to={INDEX}>
                            <img src={logo} alt={'logo'}/>
                        </Link>
                        <div>{'GetMoney, 2025'}</div>
                        <div className={cls.grid}>
                            <img src={visa} alt={'Payment'}/>
                            <img src={mc} alt={'Payment'}/>
                        </div>
                        <div className={cls.grid}>
                            <SelectCurrency block/>
                            <SelectLanguage block/>
                        </div>
                    </div>
                    <div className={cls.content}>
                        <p>{t('Limited Liability Partnership "IT Consul"')}</p>
                        <p>{t('Legal address: 050042, Kazakhstan, Almaty city, Auezovsky district, Ryskulbekova street, building 39a')}</p>
                        <p>{t('BIN')}{':'} 230740027370</p>
                        <p>{t('IIC')}{':'} {'KZ368562203131793615'}</p>
                        <p>{t('BIC')}{':'} {'KCJBKZKX'}</p>
                        <p>{t('Bank')}{':'} {'JSC Bank CenterCredit'}</p>
                        <p>{t('Mail')}{':'} {'info@togetmoney.kz'}</p>

                        <p>{t('The site togetmoney.kz is not a credit institution and does not issue loans, credits and other credit products to users of the site. The site is an aggregator of financial products of various credit institutions that have all the required licenses and certificates. The site is not responsible for any concluded credit agreements or conditions. Calculations are approximate, check the final conditions on the website of the credit institution.')}
                        </p>

                        <p>
                            <a href={lang === 'es' ? DOC_POLICY_ES : DOC_POLICY_EN} target={'_blank'} rel={'noreferrer'}>
                                {t('Personal data processing policy')}
                            </a>
                        </p>
                        <p>
                            <a href={lang === 'es' ? DOC_OFFER_ES : DOC_OFFER_EN} target={'_blank'} rel={'noreferrer'}>
                                {t('Terms and conditions of the offer')}
                            </a>
                        </p>

                        <p>{t('The payment service on the GetMoney website is carried out in accordance with the Rules of the international payment systems Visa and MasterCard on the principles of confidentiality and security of payment, for which the most modern methods of verification, encryption and data transmission over closed communication channels are used. Bank card data is entered on the secure payment page FreedomPay. No one, including the company TOO "IT Consul" (https://togetmoney.kz), can obtain the bank and personal data of the payer.')}</p>
                        <p>{t('On the page for entering bank card details, you will need to enter the card number, cardholder name, card expiration date, three-digit security code (CVV2 for VISA or CVC2 for MasterCard). All necessary data is printed on the card itself.')}</p>
                        <p>{t('The three-digit security code is the three numbers found on the back of the card.')}</p>
                        <p>{t('Next, you will be redirected to your bank\'s page to enter the 3DSecure code that will be sent to you via SMS. If you have not received the 3DSecure code, you should contact the bank that issued your card.')}</p>
                        <p>{t('Cases of refusal to make a payment:')}</p>
                        <ul>
                            <li>{t('the bank card is not intended for making payments via the Internet, which you can find out by contacting your Bank')}</li>
                            <li>{t('there are not enough funds to pay on your bank card. You can find out more about the availability of funds on your bank card by contacting the bank that issued your bank card;')}</li>
                            <li>{t('bank card details entered incorrectly;')}</li>
                            <li>{t('the bank card has expired. The card\'s expiration date is usually indicated on the front of the card (this is the month and year until which the card is valid). You can find out more about the card\'s expiration date by contacting the bank that issued the bank card;')}</li>
                        </ul>
                        <p>{t('For questions regarding payment by bank card and other questions related to the operation of the site, you can call the following number: +7 (702) 031 25 26.')}</p>
                        <p>{t('The personal information you provide (name, address, telephone, e-mail, bank card number) is confidential and will not be disclosed. Your credit card details are transmitted only in encrypted form and are not stored on our Web server.')}</p>
                        <p>{t('Detailed information about the service "Paid loan selection", rules of payment, receipt and return are set out in the Offer posted on the Website.')}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer